import React, { useEffect } from 'react';
import LoginForm from './modules/session/LoginFormExtension';
import ConfiguringApp from './modules/session/ConfiguringApp';
import UILayout from './modules/layoutv2/UILayoutExtension';
import { useSelector, useDispatch } from 'react-redux';
import ErrorBoundary from './modules/layout/ErrorBoundary';
import VERSION from './version';
import { resetState, restoreSession } from './modules/session/session-actions'
import useSessionKeepAlive from './modules/session/useSessionKeepAlive';
import { useParams } from 'react-router-dom';
import { Spinner, SpinnerSize, Text } from '@blueprintjs/core';
import { getExtensionConfig, DOWNLOAD_ASSETS_URL, EXTENSION_ASSETS_URL } from './services/api'

if(!window.bodapro){
	window.bodapro = {
		// platformType: process.versions['electron'] ? 'desktop': 'web',
		platformType: window && window.process && window.process.type ? 'desktop': 'web',
		dbQuery : () => false,
		migrateUp: () => {},
		submitCode: () => {},
		addToLog: () => {},
		getInstalledExtensions: () => {},
		api : {
			listenOn: () => {},
			removeListener: () => {},
			sendMessage: () => {},
		},
		fs: { existsSync: (v) => true },
		runWorker: () => {}, //@todo: implement web socket for server implementation
		listenOn: () => {},
		removeListener: () => {},
	};

}

const AppExtension = () => {
	const [loading, setLoading] = React.useState(true);
	const { authenticated, version, updating } = useSelector((state) => state.session);
	const [ error,setError ] = React.useState(null);
	const [ errorInfo,setErrorInfo ] = React.useState(null);
	const dispatch = useDispatch();
	let { extension } = useParams();
	const [extIconUrl, setExtIconUrl] = React.useState(null);
	const [extConfig, setExtConfig] = React.useState(null);
	const [requiresAuth, setRequiresAuth] = React.useState(true);

	console.log('extension:', extension); 

	//Restore the extension's own stored session, refreshing the token if it has
	//expired (a no-op for tokens with no `exp` claim — e.g. an extension's own
	//opaque token from a separate backend, which the host has no way to refresh)
	const loadUserDetails = (extCfg) => {
		dispatch(restoreSession(`${extCfg.id}:userDetails`));
	}

	const setFavicon = (url) => {
		var link = document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}
		link.href =  EXTENSION_ASSETS_URL + `/${extension}/assets/favicon.ico`;
		console.log('Favicon:', link.href);
	}

	useEffect(() => {
		VERSION !== version && dispatch(resetState());


		const fn = async () => {
            try {
                const config = await getExtensionConfig(extension);
                
                setExtConfig(config);
                setExtIconUrl(config?.webOptions.favicon);

				//set window title
				document.title = config?.label || 'BodaPro';

				//check if authentication is needed 
				if(config?.webOptions?.requiresAuth){
					setRequiresAuth(true);

					
				}else{
					setRequiresAuth(false);
				}

				loadUserDetails(config);        

            } catch (e) {

            }

            setLoading(false);
        }

        fn();

	},[1]);

	//Silently refresh the access token before it expires — unlike the main
	//app (useSessionKeepAlive in App.js), this tree had no keep-alive at all
	//until extConfig loads, dispatched with 'bodapro-user' (a no-op key, since
	//nothing is authenticated under it yet)
	useSessionKeepAlive(extConfig ? `${extConfig.id}:userDetails` : undefined);

	//show updating skin
	// if(updating) {
	// 	return <ConfiguringApp />;
	// }

	// authentication
	if(window.bodapro?.platformType == 'web'){//show authentication for web

		setFavicon(extIconUrl);

		//@todo: load single extension
		if(extension === undefined || extConfig === null){
			return <div
						style={{
							marginTop: '100px',
							'textAlign': 'center'
						}}>
				<Spinner size={SpinnerSize.LARGE}/>
				<span><Text>Loading ...</Text></span>
			</div>
		}
		
		console.log('requiresAuth: ', requiresAuth, 'authenticated: ', authenticated);

		if (requiresAuth && authenticated === false) {
			return (
				<ErrorBoundary>
					<LoginForm extConfig={extConfig}/>
				</ErrorBoundary>
			);
		}
	}


	return (
		<ErrorBoundary>
			<UILayout extConfig={extConfig}/>
		</ErrorBoundary>
	);
}

export default AppExtension;